<template>
  <popup
    :is-closable="true"
    :title="isEdit ? 'Edit project' : 'New Project'"
    @close="$emit('close')"
  >
    <div style="width: 400px">
      <z-input
        v-model="name"
        label="Project name"
      />
      <z-button
        class="mt-4"
        @click="$emit('saved', name)"
      >
        {{ isEdit ? 'Save changes' : 'Create project' }}
      </z-button>
    </div>
  </popup>
</template>

<script>
import Popup from '@/global/ui/Popup'
import ZInput from '@/global/ui/Input'
import ZButton from '@/global/ui/Button'
export default {
  name: 'ProjectPopup',
  components: { ZButton, ZInput, Popup },
  props: {
    initialName: { type: String, default: null }
  },
  data () {
    return {
      name: '',
      isEdit: false
    }
  },
  mounted () {
    if (this.initialName !== null) {
      this.isEdit = true
      this.name = this.initialName
    }
  }
}
</script>
